/** Human key for a node, for example DH-104. */
export function nodeKey(prefix: string, number: number): string {
  return `${prefix}-${number}`;
}
